import PropTypes from 'prop-types';
import { Input, Stack } from '@etg/wings';
import { MaskedInput, getInputMaskConfig } from '@eti/components';
import { useTranslation, useValidation } from '@eti/providers';
import { css } from '@eti/styles';
import { constants, date, string } from '@eti/utils';
import { Field as ReduxFormField } from 'redux-form';
import { MANULIFE_DATE_OF_BIRTH } from '../utils/constants';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  ADULT,
  CHILD,
  INFANT
} = constants.ageTypes;
const {
  DATE_PATTERN
} = constants.inputFieldPatterns;
const inputWrapperStyles = css`
  margin-inline-start: 24px;
  margin-top: 16px;
  max-width: 150px;
`;
const MaskedDateInput = _ref => {
  let {
    dateFormat,
    id,
    input,
    isReadOnly,
    meta,
    name,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  const hasError = Boolean(meta.invalid && !meta.active && (input.value !== '' || meta.touched));
  const errorId = hasError ? `${name}-error` : undefined;
  const descriptionId = !isReadOnly ? `${id}-description` : undefined;
  const description = !isReadOnly ? string.insertArgument(t('Manulife.DateOfBirth.Hint.Label'), dateFormat.toUpperCase()) : undefined;
  const {
    mask,
    pipe
  } = getInputMaskConfig(date.getBirthDateConstraints(new Date()), dateFormat);
  return /*#__PURE__*/_jsxs(Stack, {
    className: inputWrapperStyles,
    spacing: 4,
    children: [/*#__PURE__*/_jsx(Input.Label, {
      htmlFor: id,
      children: t('Manulife.DateOfBirth.Label')
    }), /*#__PURE__*/_jsx(MaskedInput, {
      autoComplete: "off",
      autoCorrect: "off",
      "data-testid": `${name}-input`,
      descriptionId: descriptionId,
      errorId: errorId,
      hasError: hasError,
      id: id,
      inputMode: "numeric",
      isReadOnly: isReadOnly,
      mask: mask,
      name: name,
      pattern: DATE_PATTERN,
      pipe: pipe,
      placeholder: dateFormat.toUpperCase(),
      spellCheck: "false",
      ...input,
      ...props
    }), /*#__PURE__*/_jsx(Input.Meta, {
      description: description,
      descriptionId: descriptionId,
      error: meta.error,
      errorId: errorId,
      hasError: hasError
    })]
  });
};
MaskedDateInput.propTypes = {
  dateFormat: PropTypes.string,
  id: PropTypes.string,
  input: PropTypes.shape({
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    value: PropTypes.string
  }),
  isReadOnly: PropTypes.bool,
  meta: PropTypes.shape({
    active: PropTypes.bool,
    // eslint-disable-line react/boolean-prop-naming
    error: PropTypes.string,
    invalid: PropTypes.bool,
    // eslint-disable-line react/boolean-prop-naming
    touched: PropTypes.bool // eslint-disable-line react/boolean-prop-naming
  }),
  name: PropTypes.string
};
const ManulifeTravelerDateOfBirth = _ref2 => {
  let {
    ageType = ADULT,
    dateFormat = 'yyyy-MM-dd',
    id,
    isReadOnly = false,
    onBlur = () => {},
    productName
  } = _ref2;
  const name = `traveler-${id}.dateOfBirth`;
  const validate = useValidation(`${MANULIFE_DATE_OF_BIRTH}-${id}-${ageType}`);
  return /*#__PURE__*/_jsx(ReduxFormField, {
    component: MaskedDateInput,
    dateFormat: dateFormat,
    id: `${productName}-traveler-${id}.dateOfBirth`,
    isReadOnly: isReadOnly,
    name: name,
    onBlur: onBlur,
    props: {
      name
    },
    validate: validate
  });
};
ManulifeTravelerDateOfBirth.propTypes = {
  ageType: PropTypes.oneOf([ADULT, CHILD, INFANT]),
  dateFormat: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  onBlur: PropTypes.func,
  productName: PropTypes.string
};
export default ManulifeTravelerDateOfBirth;
//# sourceMappingURL=ManulifeTravelerDateOfBirth.js.map